/**
 * Seminar-participant (sem-tn-liste) status values. "active" was a bare string
 * literal across the invoice/email read + filter + write sites.
 */
export const PARTICIPANT_STATUS = {
  ACTIVE: "active",
  /** Set by a storno on the participants it cancelled; they stay linked to the
   *  invoice they were billed on, which is how the invoice still shows them. */
  CANCELLED: "cancelled",
} as const;
